import React from 'react'
import { CustomInputTextArea } from '../../common/formControls'

const InstructionsAndInfo = ({ pickupInstruction, setPickupInstruction, additionalInfo, setAdditionalInfo }) => {
    return (
        <>
                 <div className="InstructionsAndInfo">
                    <div className='w-100 d-flex flex-column gap-2'>                                    
                        <CustomInputTextArea
                            name="pickupInstruction"
                            label="Key Pickup Instructions"
                            placeholder="Enter Pickup Instructions"
                             
                            isFormControl
                            value={pickupInstruction}
                            onChange={(e) => setPickupInstruction(e.target.value)}
                            isError={undefined}
                            errorMessages=" Answer is required "
                            myClassName="normal_text black"
                            rows={5}
                            width={'100%'}
                        />
                        </div> 
                        <div className='w-100 d-flex flex-column gap-2'>                  
                        <CustomInputTextArea
                            label={"Additional Instructions"}
                            name="additionalInfo"
                            placeholder="Enter Additional Instructions"
                            isFormControl
                            value={additionalInfo}
                            onChange={(e) => setAdditionalInfo(e.target.value)}
                            isError={undefined}
                            errorMessages="Additional Info is required "
                            myClassName="normal_text black"
                            rows={5}
                            width={'100%'}
                        />                     
                    </div>
                </div>
                
          
        </>
    )
}

export default InstructionsAndInfo